window.addEventListener('DOMContentLoaded', () => {
  initFaqExpanders();
  initScrollTop();
});

const initFaqExpanders = () => {
  document.querySelectorAll('.faq ul li').forEach((elm) => {
    const title = elm.querySelector('h3');
    const content = elm.querySelector('p');
    content.dataset.height = `${content.clientHeight}px`;
    content.style.height = 0;
    title.addEventListener('click', () => {
      const classList = elm.classList;
      const closed = classList.contains('closed');
      classList.toggle('closed')
      if (closed) {
        content.style.height = content.dataset.height;
      } else {
        content.style.height = 0;
      }
    })
    elm.classList.add('closed');
  });
}

const initScrollTop = () => {
  const button = document.getElementById('scrollTop');
  const header = document.querySelector('header');
  button.addEventListener('click', () => {
    header.scrollIntoView({behavior: 'smooth'});
  });
  const observer = new IntersectionObserver((entries)=>{
    const headerVisible = entries[0].isIntersecting;
    button.classList = headerVisible ? ['hidden'] : []
  });
  observer.observe(header);
}
